import React from 'react';
import { withFormsy } from 'formsy-react';

import FieldError from './FieldError'

class Input extends React.Component {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    this.props.setValue(event.currentTarget.value);
  }

  render() {
    // An error message is returned only if the component is invalid and has been interacted with
    const errorMessage = !this.props.isPristine() ? this.props.getErrorMessage() : null;

    return (
      <div className={this.props.className}>
        <input
          autoComplete="off"
          onChange={this.changeValue}
          placeholder={this.props.placeholder}
          className={`form-control ${errorMessage ? "has-error" : ""}`}
          name={this.props.name}
          value={this.props.getValue() || ''}
          type={this.props.type || 'text'}
          id={this.props.id}
        />

        { errorMessage && <FieldError message={errorMessage} /> }
      </div>
    );
  }
}

export default withFormsy(Input);
